import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function useAdminSearch(query: string) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.adminSearch.search.queryOptions({ input: { query } }),
    enabled: query.length > 0,
  })
}
